<template>
  <div> <!-- Only one element for Transition -->
    <div class="row">
      <div class="col-12">
        <TextInputComponent
          value-key="userInfo.specialRequests"
          label="Demandes particulières"
          placeholder="Indiquez vos demandes particulières"
          type="multiline"
          :required="false"
          class="mb-3"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TextInputComponent
          value-key="userInfo.allergies"
          label="Allergies"
          placeholder="Indiquez vos allergies"
          type="multiline"
          :required="false"
          class="mb-3"
        />
      </div>
    </div>

    <PageBottomMessage message-key="pageRequests"></PageBottomMessage>
  </div>
</template>
<script setup lang="ts">
// const participation = defineModel<UserParticipation>();
</script>
